import React from 'react'

export default function CustomersAccountsListFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #customer-accounts-list-footer-container {
          display: flex;
          margin-right: 17px;
        }
      `}
      </style>
    </React.Fragment>
  )
}
